import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const BaseLayoutRoot = styled(Col)(
    () => css`
        flex: 1;
        min-height: 100vh;
    `,
);
